/**
 * Simplified Variant Swapper - v25
 *
 * With the Liquid fixed, this script's only job is to handle variant
 * image switching when a user interacts with the product options app.
 */
function initializeDefinitiveFix() {
  const dataIslandElement = document.getElementById('my-variant-data-island');
  if (!dataIslandElement) return;

  const variantMediaMap = JSON.parse(dataIslandElement.textContent);
  const appContainer = document.querySelector('.best-custom-product-options');
  const mediaGallery = document.querySelector('media-gallery');

  if (!appContainer || !mediaGallery) return;

  const handleInteraction = () => {
    // A short delay to allow the app to update the variant input
    setTimeout(() => {
      const shopifyVariantInput = document.querySelector('form input[name="id"]');
      if (!shopifyVariantInput) return;

      const currentVariantId = shopifyVariantInput.value;
      const requiredMediaId = variantMediaMap[currentVariantId];

      if (requiredMediaId) {
        // Find the thumbnail button that controls the variant's image
        const targetThumbnailButton = document.querySelector(`button.thumbnail[data-target*="${requiredMediaId}"]`);
        
        // If we find the button, click it to update the gallery
        if (targetThumbnailButton && targetThumbnailButton.getAttribute('aria-current') !== 'true') {
          targetThumbnailButton.click();
        }
      }
    }, 100);
  };

  appContainer.addEventListener('change', handleInteraction);
  appContainer.addEventListener('click', handleInteraction);
}

// Run the script when the page is ready.
document.addEventListener('DOMContentLoaded', initializeDefinitiveFix);
document.addEventListener('shopify:section:load', initializeDefinitiveFix);